import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { StaticQuery, graphql } from "gatsby"

function Seo({ description, lang, meta, keywords, title }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const url = data.allWpPost.edges[0].node.slug
          || data.site.siteMetadata.siteUrl

        const image = data.site.siteMetadata.siteUrl + data.ogp.publicURL

        const imgw = 1200
        const imgh = 630
        const metaDescription =
          description ||
          data.wp.generalSettings.description ||
          data.site.siteMetadata.description
        const titleText = title
          ? `${title} | ${
              data.wp.generalSettings.description ||
              data.site.siteMetadata.title
            }`
          : data.wp.generalSettings.description || data.site.siteMetadata.title
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={titleText}
            titleTemplate={`%s`}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:url`,
                content: url,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                property: `og:locale`,
                content: data.site.siteMetadata.locale,
              },
              {
                property: `og:image`,
                content: image,
              },
              {
                property: `og:image:width`,
                content: imgw,
              },
              {
                property: `og:image:height`,
                content: imgh,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:creator`,
                content: "ZIMA",
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                    name: `keywords`,
                    content: keywords.join(`, `),
                  }
                  : []
              )
              .concat(meta)}
          />
        )
      }}
    />
  )
}

Seo.defaultProps = {
  lang: `ja`,
  meta: [],
  keywords: [],
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        lang
        locale
        description
        siteUrl
        fbappid
      }
    }
    wp {
      generalSettings {
        title
        description
      }
    }
    allWpPost {
      edges {
        node {
          title
          excerpt
          slug
          featuredImage {
            node {
              mediaItemUrl
              localFile {
                publicURL
                childImageSharp {
                  fluid(maxWidth:500) {
                    ...GatsbyImageSharpFluid_withWebp_tracedSVG
                  }
                }
              }
            }
          }
        }
      }
    }
    ogp: file(relativePath: { eq: "ogp.png"}) {
      publicURL
    }
  }
`

export default Seo
